
const Skeleton = ({ width, height, className = '', variant = 'rect' }) => {
  const baseStyle = {
    background: 'linear-gradient(90deg, var(--bg-secondary) 25%, var(--bg-card) 50%, var(--bg-secondary) 75%)',
    backgroundSize: '200% 100%',
    animation: 'shimmer 1.5s infinite',
    borderRadius: variant === 'circle' ? '50%' : '8px',
    width: width || '100%',
    height: height || '20px',
  };

  return (
    <>
      <style>{`
        @keyframes shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
      <div style={baseStyle} className={className} />
    </>
  );
};

export const CardSkeleton = () => (
  <div style={{
    padding: '16px',
    background: 'var(--bg-card)',
    border: '1px solid var(--border-subtle)',
    borderRadius: '12px'
  }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
      <Skeleton width="40px" height="40px" variant="circle" />
      <div style={{ flex: 1 }}>
        <Skeleton width="60%" height="14px" />
        <div style={{ height: '6px' }} />
        <Skeleton width="40%" height="10px" />
      </div>
    </div>
    <Skeleton height="12px" />
    <div style={{ height: '6px' }} />
    <Skeleton width="80%" height="12px" />
  </div>
);

export const ListSkeleton = ({ count = 3 }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} style={{
        padding: '12px',
        background: 'var(--bg-card)',
        border: '1px solid var(--border-subtle)',
        borderRadius: '10px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      }}>
        <Skeleton width="36px" height="36px" variant="rect" />
        <div style={{ flex: 1 }}>
          <Skeleton width="50%" height="12px" />
          <div style={{ height: '4px' }} />
          <Skeleton width="70%" height="10px" />
        </div>
      </div>
    ))}
  </div>
);

export const ChartSkeleton = () => (
  <div style={{
    padding: '16px',
    background: 'var(--bg-card)',
    border: '1px solid var(--border-subtle)',
    borderRadius: '12px'
  }}>
    <Skeleton width="40%" height="16px" />
    <div style={{ height: '12px' }} />
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: '8px', height: '120px' }}>
      {[60, 80, 45, 90, 70, 85, 55].map((h, i) => (
        <Skeleton key={i} width="100%" height={`${h}%`} />
      ))}
    </div>
  </div>
);

export const StatsSkeleton = () => (
  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '12px' }}>
    {[1, 2, 3, 4].map((i) => (
      <div key={i} style={{
        padding: '14px',
        background: 'var(--bg-card)',
        border: '1px solid var(--border-subtle)',
        borderRadius: '10px'
      }}>
        <Skeleton width="50%" height="10px" />
        <div style={{ height: '8px' }} />
        <Skeleton width="70%" height="20px" />
      </div>
    ))}
  </div>
);

export default Skeleton;
